import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Partner\ChiftInvoicing\DeleteChiftInvoicingConnexionController::__invoke
* @see app/Http/Controllers/Partner/ChiftInvoicing/DeleteChiftInvoicingConnexionController.php
* @route '/api/company/{company}/partners/chift-invoicing'
*/
const DeleteChiftInvoicingConnexionController = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: DeleteChiftInvoicingConnexionController.url(args, options),
    method: 'delete',
})

DeleteChiftInvoicingConnexionController.definition = {
    methods: ["delete"],
    url: '/api/company/{company}/partners/chift-invoicing',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Partner\ChiftInvoicing\DeleteChiftInvoicingConnexionController::__invoke
* @see app/Http/Controllers/Partner/ChiftInvoicing/DeleteChiftInvoicingConnexionController.php
* @route '/api/company/{company}/partners/chift-invoicing'
*/
DeleteChiftInvoicingConnexionController.url = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return DeleteChiftInvoicingConnexionController.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Partner\ChiftInvoicing\DeleteChiftInvoicingConnexionController::__invoke
* @see app/Http/Controllers/Partner/ChiftInvoicing/DeleteChiftInvoicingConnexionController.php
* @route '/api/company/{company}/partners/chift-invoicing'
*/
DeleteChiftInvoicingConnexionController.delete = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: DeleteChiftInvoicingConnexionController.url(args, options),
    method: 'delete',
})

export default DeleteChiftInvoicingConnexionController